/**
 * State-aware Rival tap dialogue — MVP PR A1.
 *
 * Replaces the static `PalletTown_ProfessorOaksLab_EventScript_Rival`
 * entry in dialogue.ts (which returned "Yo, RED! What're you doing
 * here?" on every tap regardless of state). The dispatcher reads the
 * lab scene state machine and returns the cartridge-appropriate line
 * per phase.
 *
 * State → dialogue:
 *
 *     ┌───────────────────────────────────────────────────────────┐
 *     │ state │ dialogue (cartridge text key)                     │
 *     ├───────┼───────────────────────────────────────────────────┤
 *     │   0   │ defensive fallback (rival is hidden pre-intercept) │
 *     │   1   │ RivalFedUpWithWaiting — "Gramps! I'm fed up with   │
 *     │       │   waiting!" (cartridge: same line as the           │
 *     │       │   monologue's first interjection)                  │
 *     │   2   │ "Hurry up, RED! Pick one!" (bridge dialogue while  │
 *     │       │   waiting for the pick — poke flavor consistent    │
 *     │       │   with cartridge's "I'm fed up" energy)             │
 *     │   3   │ RivalMyMonLooksTougher — "My POKéMON looks a lot   │
 *     │       │   tougher than yours."                              │
 *     │   4   │ defensive fallback (rival has exited; static NPC   │
 *     │       │   is hidden via FLAG_HIDE_RIVAL_IN_LAB so tap      │
 *     │       │   surface shouldn't exist)                         │
 *     └───────────────────────────────────────────────────────────┘
 *
 * State-4 defensive fallback only fires if a future bug exposes the
 * rival NPC after he exits; the production path keeps him hidden.
 */
import type { Handler, ScriptCtx } from '../scriptRunner';
import { getLabSceneState, LAB_SCENE_STATES } from '../labScene';

const RIVAL_FED_UP = ['RIVAL: Gramps! I\'m fed up with waiting!'];
const RIVAL_HURRY_UP = ['RIVAL: Hurry up, RED! Pick one!'];
const RIVAL_TOUGHER = ['RIVAL: My POKéMON looks a lot tougher than yours.'];
const RIVAL_DEFENSIVE_FALLBACK = ['RIVAL: …'];

export const labRivalTapHandler: Handler = async (ctx: ScriptCtx) => {
  const state = getLabSceneState();
  let pages: string[];
  switch (state) {
    case LAB_SCENE_STATES.MONOLOGUE_PENDING:
      pages = RIVAL_FED_UP;
      break;
    case LAB_SCENE_STATES.PRE_PICK:
      pages = RIVAL_HURRY_UP;
      break;
    case LAB_SCENE_STATES.POST_PICK:
      pages = RIVAL_TOUGHER;
      break;
    default:
      pages = RIVAL_DEFENSIVE_FALLBACK;
      break;
  }
  ctx.worldScene.showDialogue(pages, null);
};
